import React, { useEffect } from 'react';
import { Snackbar, SnackbarContent, CircularProgress, IconButton } from "@mui/material";
import Slide from '@mui/material/Slide';
import Alert from '@mui/material/Alert';
import i18next from "i18next";

function AlertComp(props) {
  const vertical = "bottom";
  const horizontal = "right";

  const [open, setOpen] = React.useState(props.open);
  const [type, settype] = React.useState(props.type);

  React.useEffect(() => {
    setOpen(props.open);
    settype(props.type);
    console.log(props);
  }, [props.open]);

  function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

  const [Transition, setTransition] = React.useState({
    Transition: SlideTransition,
  });

  const handleClose = () => {
    setOpen(false);
  };
  // console.log(props,open);

  return (
    <>
      {(props.msg == "progress" ||
        props.msg == "analyze" ||
        props.msg == "cart") &&
      props.msg != "" ? (
        <Snackbar
          open={open}
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          // autoHideDuration={600000}
          onClose={handleClose}
        >
          <SnackbarContent
            message={
              <span style={{ display: "flex", alignItems: "center" }}>
                {props.msg != "cart" && (
                  <CircularProgress size={24} style={{ marginRight: 10 }} />
                )}
                {props.msg == "cart"
                  ? "Product Added to Cart"
                  : props.msg == "progress"
                  ? "Processing photo..."
                  : "Generating result..."}
              </span>
            }
          />
        </Snackbar>
      ) : props?.page ? (
        <Snackbar
          open={open}
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <SnackbarContent
            message={
              <span style={{ display: "flex", alignItems: "center" }}>
                {props.page == "report" && props.msg == "processing" && (
                  <CircularProgress size={24} style={{ marginRight: 10 }} />
                )}
                {props.page == "report" && props.msg == "processing"
                  ? i18next.t("Generating your report")
                  : props.page == "report" && props.msg == "completed"
                  ? i18next.t("Processing completed")
                  : props.page == "report" && props.msg == "error"
                  ? i18next.t("Error Processing")
                  : ""}
              </span>
            }
          />
        </Snackbar>
      ) : (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          // autoHideDuration={3000}
          TransitionComponent={Transition.Transition}
          // message={props.msg}
          key={vertical + horizontal}
        >
          <Alert
            onClose={handleClose}
            severity={type}
            variant="filled"
            sx={{ width: "90%" }}
          >
            {props.msg}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default AlertComp;